import { useTranslation } from 'react-i18next'
import { LanguageMenu } from '@clari/ui'
import { LOCALE_NATIVE_NAMES, SUPPORTED_LOCALES, type Locale } from '@clari/i18n'

/**
 * Customer-facing language switcher — a compact globe trigger that opens a
 * dropdown of the 9 supported locales (FR/EN/AR/ES/DE/IT/PT/NL/PL).
 *
 * Available pre-auth (per CLAUDE.md §10 — switching must work on the login
 * screen without any session). Presentation lives in @clari/ui's
 * <LanguageMenu>; this wrapper just wires i18next in.
 */
export function LanguageSwitcher() {
  const { i18n, t } = useTranslation('common')
  const current = (i18n.resolvedLanguage ?? i18n.language) as Locale

  return (
    <LanguageMenu
      locales={SUPPORTED_LOCALES}
      current={current}
      nativeNames={LOCALE_NATIVE_NAMES}
      label={t('language.switch_label')}
      onSelect={(locale) => {
        void i18n.changeLanguage(locale)
      }}
    />
  )
}
